import { ModuleWithProviders, NgModule }     from '@angular/core';
import { CommonModule }                      from '@angular/common';
import { CsButtonBarComponent }              from './cs-button-bar.component';
import { BottomBarQuery }                    from './state/bottom-bar.query';
import { BottomBarService }                  from './state/bottom-bar.service';
import { BottomBarStore }                    from './state/bottom-bar.store';
import { MatTooltipModule as MatTooltipModule }                  from '@angular/material/tooltip';
import { TranslateModule }                   from '@ngx-translate/core';
import { ComponentTranslationLoaderService } from '@cs/common';
import { CsSharedModule }                    from '@cs/components/shared';
import { ReactiveFormsModule }               from '@angular/forms';
import { MatDialogModule }                   from '@angular/material/dialog';


@NgModule({
  declarations: [
    CsButtonBarComponent
  ],
  imports:      [
    CommonModule,
    TranslateModule,
    MatTooltipModule,
    MatDialogModule,
    CsSharedModule,
    ReactiveFormsModule
  ],
  providers:    [],
  exports:      [
    CsButtonBarComponent
  ]
})
export class CsBottomButtonBarModule {
  static forRoot(): ModuleWithProviders<CsBottomButtonBarModule> {
    return {
      ngModule:  CsBottomButtonBarModule,
      providers: [BottomBarQuery, BottomBarService, BottomBarStore]
    };
  }

  constructor(loader: ComponentTranslationLoaderService) {
    loader.registerComponentModule('pm-bottom-button-bar');
  }
}

